import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent  implements OnInit {

  loginForm: FormGroup = new FormGroup({});
  passwordShow: any = 'password';
  showpwd: boolean = false;
  showPassword:boolean =false;
  formSubmitted:boolean = false;
  userRole:any;
  loggedInUserCompanyID:any;
  loggedInCompanyID:any;
  fiscalYear:any;
  constructor(public router: Router,private http: HttpService,private config:Config,
    private loader:LoaderService,private fb: FormBuilder,private encryptionService:EncryptionService,
  ) { }

  ngOnInit() {
    this.inializeLoginForm();
  }
  ionViewWillEnter() {
    sessionStorage.removeItem('currentToken');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('loggedInUser');
    sessionStorage.removeItem('loggedInUserId');
    sessionStorage.removeItem('loggedInUserRole');
    sessionStorage.removeItem('department');

  }
  inializeLoginForm(){
    this.loginForm = this.fb.group({
      email: ['', [Validators.required,Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      password: ['', Validators.required],
    });
  }
  onEyeClick() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.passwordShow = "text";
      this.showpwd = true;
    } else {
      this.passwordShow = "password";
      this.showpwd = false;
    }
  }
  onClickLogin(){
    this.formSubmitted = true;
    this.loginForm.controls['email'].setValue(this.loginForm.value.email?.trim());
    if (this.loginForm.valid) {
      this.formSubmitted = false;
      const request = {
        "deviceId": "",
        "email": this.loginForm.value.email,
        "empCode":  "",
        "fcmToken": "",
        "password": this.loginForm.value.password
      }
      this.loader.simpleLoaderWithDuration();
      this.http.callPostServiceForLogin(this.config.login, request)
        .subscribe((data: any) => {
          if(data?.accessToken){
            console.warn("userCompanyHr", data.userProfile.userCompanyHr);
            
            sessionStorage.setItem('currentToken', data?.accessToken);
            sessionStorage.setItem('department', data?.userProfile?.department);
            sessionStorage.setItem('userCompanyHr', data.userProfile.userCompanyHr);
            sessionStorage.setItem('refreshToken', data?.refreshToken);
            sessionStorage.setItem('loggedInUserName',data?.userProfile?.firstName +' '+ data?.userProfile?.lastName);
            sessionStorage.setItem('loggedInUserId',data?.userProfile?.id);
            this.userRole = this.encryptionService.encryptData(data?.roles[0]?.displayName)
            sessionStorage.setItem('loggedInUserRole',this.userRole);
            sessionStorage.setItem('userEmail',data?.userProfile?.email);
            sessionStorage.setItem('empCode',data?.userProfile?.empCode);
            sessionStorage.setItem('isDottedManager',data?.userProfile?.isDottedManager)
            this.loggedInCompanyID = this.encryptionService.encryptData(String(data?.userProfile?.companyId));
            sessionStorage.setItem('loggedInUserCompanyID',this.loggedInCompanyID);
            this.loggedInUserCompanyID = data?.userProfile?.companyId
            this.loader.dismissLoader();
            if(data?.roles[0]?.displayName?.toLowerCase() == 'super admin' 
            || data?.roles[0]?.displayName?.toLowerCase() == 'phi admin'
            || data?.roles[0]?.displayName?.toLowerCase() == 'phi finance & accounts'){
              sessionStorage.setItem('subModuleButtonColor','#393186');
              sessionStorage.setItem('buttonColorName','#F6921E');
              sessionStorage.setItem('moduleNameColor','#F6921E');
              this.router.navigate(['/home/companies']);
            } else{
              // if(data?.roles[0]?.displayName=='HR Admin' || data?.roles[0]?.displayName=='Admin'){
                this.getMdIdByCompany();
              // }
              data?.roles?.forEach((ele: any) => {
                if (ele?.displayName == 'Admin') {
                  this.userRole = this.encryptionService.encryptData(ele?.displayName)
                  sessionStorage.setItem('loggedInUserRole',this.userRole);                }
              });
              this.getCompanyDataByCompID();
              sessionStorage.setItem('loggedInUserRoles',JSON.stringify(data?.roles));
            }
          }else{
            window.alert(data?.data);
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  onClickForgotPassword(){
    this.router.navigate(['/login/forgot-password']);
  }
  getCompanyDataByCompID() {
    this.loader.simpleLoaderWithDuration();
    this.http.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.loader.dismissLoader();
      sessionStorage.setItem('loggedInUserCompanyName', data?.data?.companyName);
      sessionStorage.setItem('loggedInCompanyData',JSON.stringify(data?.data));
      sessionStorage.setItem('subModuleButtonColor',data?.data?.subModuleButtonColor);
      sessionStorage.setItem('buttonColorName',data?.data?.buttonColorName);
      sessionStorage.setItem('moduleNameColor',data?.data?.moduleNameColor);
      sessionStorage.setItem('dashboardColorName',data?.data?.dashboardColorName)
      sessionStorage.setItem('companyLogo',data?.data?.logo);
      this.fiscalYear = this.encryptionService.encryptData(data?.data?.fiscalYear);
      sessionStorage.setItem('loggedInCompanyFiscalyear',this.fiscalYear); 
      sessionStorage.setItem('loggedInCompanyIndustryName',data?.data?.industry?.industryName);
      sessionStorage.setItem('loggedInCompanyIndustryID',data?.data?.industry?.id);
       sessionStorage.setItem('loggedInCompanyMDCode',data?.data?.employeeIdOfMD)
      if(sessionStorage.getItem('empCode')==data?.data?.employeeIdOfMD){
        sessionStorage.setItem('loggedInUserIsMD','true'); 
      }
      this.router.navigate(['/home/hrportal/myhome']);
    })
  }
  loggedInCompanyMDID:any;
  getMdIdByCompany(){
    var loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.http.callGetService(this.config.getMdIdByCompany + loggedInUserCompanyID).subscribe((data: any) => {
      this.loggedInCompanyMDID = this.encryptionService.encryptData(String(data?.data?.id));
      sessionStorage.setItem('loggedInCompanyMDID',this.loggedInCompanyMDID)
    })
  }
}
